import {
  getTheKybCountryCodeByCountryName,
  THE_KYB_COUNTRY_CODES,
} from "@/components/shared/constants/general.const";
import { getIsoCountryCodeFromHeadquarters } from "@shared/worldCountryIsoCodes";
import "./CountryFlag.css";

export function isoAlpha2FromHeadquartersCountry(countryName?: string | null): string | null {
  const n = countryName?.trim();
  if (!n) return null;
  const row = THE_KYB_COUNTRY_CODES.find((c) => c.name === n);
  if (row) return row.code;
  const kybCode = getTheKybCountryCodeByCountryName(n);
  if (kybCode) return kybCode;
  return getIsoCountryCodeFromHeadquarters(n);
}

function flagImageUrl(alpha2: string): string {
  return `https://flagcdn.com/w40/${alpha2.toLowerCase()}.png`;
}

type CountryFlagProps = {
  /** Headquarters country display name */
  country?: string | null;
  /** ISO 3166-1 alpha-2 code (takes precedence when both are provided) */
  alpha2?: string | null;
  className?: string;
  title?: string;
};

export default function CountryFlag({ country, alpha2, className, title }: CountryFlagProps) {
  const iso =
    alpha2?.trim().toUpperCase() ||
    (country ? isoAlpha2FromHeadquartersCountry(country) : null);

  if (!iso || iso.length !== 2 || !/^[A-Z]{2}$/.test(iso)) {
    return null;
  }

  const ariaLabel = title ?? (country?.trim() ? `${country.trim()} flag` : `${iso} flag`);

  return (
    <span
      className={className ? `gt-country-flag ${className}` : "gt-country-flag"}
      role="img"
      aria-label={ariaLabel}
      title={country?.trim() || undefined}
    >
      <img src={flagImageUrl(iso)} alt="" loading="lazy" />
    </span>
  );
}
